import React, { Component } from 'react';
import Thead from './Thead'
import Tbody from './Tbody'

class Table extends Component {
  state = {
    sort: {
      direction: 'asc',
      columnIdx: null,
    },
    isLoading: true,
  }

  sortRows = ({ rows, columns, direction, columnIdx }) => {
    const revertResults = direction === SortDirection.DESC;
    const columnProps = columns[columnIdx];
    const shouldNotSort = !columnProps || columnProps.sortable === false;

    if (shouldNotSort) {
      return rows;
    }

    const sorter = createSorter({
      columns,
      columnIdx,
    });

    const sortedRows = rows.sort(sorter);

    return revertResults
      ? sortedRows.reverse()
      : sortedRows;
  }

  onSortData = (columnIdx) => async (event) => {
    const { rows, columns, sort } = this.state;
    const direction = sort.direction === SortDirection.ASC
      ? SortDirection.DESC
      : SortDirection.ASC;

    const sortedRows = this.sortRows({
      rows,
      columns,
      columnIdx,
      direction,
    });

    await this.updateTableState({
      sortedRows,
      columnIdx,
      direction,
      shouldUpdateSortState: true,
    });
  }

  updateTableState = ({
    sortedRows,
    columnIdx,
    direction,
    shouldUpdateSortState = false,
    extendedState = {},
  }) => new Promise(resolveAfterStateUpdate => {
    const sortState = {
      columnIdx,
      direction,
    };
    const afterSortState = {
      rows: sortedRows,
    };

    if (shouldUpdateSortState) {
      afterSortState.sort = sortState;
    }

    this.setState({
      ...afterSortState,
      ...extendedState,
    }, resolveAfterStateUpdate);
  });

  async componentWillReceiveProps(nextProps) {
    const { columns, rows } = nextProps;
    const { sort } = this.state;
    const { columnIdx, direction } = sort;

    const isLoading = !Array.isArray(rows);

    const sortedRows = this.sortRows({
      columnIdx,
      rows,
      columns,
      direction,
    });

    const extendedState = {
      columns,
      isLoading,
    }

    await this.updateTableState({
      sortedRows,
      columnIdx,
      direction,
      extendedState
    });
  }

  render() {
    const { columns, rows, isLoading, sort } = this.state;

    return (
      <table className="flexible-table">
        <Thead columns={columns}
          onColumnClick={this.onSortData}
          isLoading={isLoading}
          sort={sort}
          {...this.props}
        />
        <Tbody columns={columns}
          rows={rows}
          getColumnContents={getColumnContents}
          isLoading={isLoading}
        />
      </table>
    );
  }
}

const SortDirection = Object.freeze({
  ASC: 'asc',
  DESC: 'desc',
});

function createSorter({ columns, columnIdx, revertResults }) {
  return function sorter(rowA, rowB) {
    const columnProps = columns[columnIdx];
    const columnData = {
      a: getColumnData(rowA, columnIdx),
      b: getColumnData(rowB, columnIdx),
    };

    const valueA = resolveColumnSortValue(columnProps, columnData.a);
    const valueB = resolveColumnSortValue(columnProps, columnData.b);

    const sort = columnProps.sort ? columnProps.sort : defualtSort;
    const comparator = sort(valueA, valueB);

    return comparator;
  }
}

function defualtSort(a, b) {
  a = (a === null || a === undefined) ? -Infinity : a;
  b = (b === null || b === undefined) ? -Infinity : b;

  if ([typeof a, typeof b].every(type => type === 'string')) {
    return a.localeCompare(b);
  }

  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }

  return 0;
}

function getColumnContents(row) {
  return (columnProps, columnIdx) => {
    const columnData = getColumnData(row, columnIdx);

    return resolveColumnValue(columnProps, columnData);
  }
}

function getColumnRawValue(props, data) {
  return typeof props.rawValue === 'function'
    ? props.rawValue(data)
    : null;
}

function resolveColumnSortValue(props, data) {
  return getColumnRawValue(props, data)
    || resolveColumnValue(props, data);
}

function resolveColumnValue(props, data) {
  const rawValue = getColumnRawValue(props, data);
  let value;

  if (props.render) {
    value = props.render({ ...data, rawValue })
  } else if (props.key) {
    value = data[props.key];
  } else {
    value = data;
  }

  if (value === undefined) {
    value = '';
  }

  return value;
}

function getColumnData(row, columnIdx) {
  if (Array.isArray(row)) {
    return row[columnIdx];
  }

  return row;
}

export default Table;



// WEBPACK FOOTER //
// ./src/Table/index.js